<template>
    <div class="content-wrapper flex flex-direction flex-sub padding-sm">
        <div class="bg-white padding-sm flex-sub">
            <div class="search-container flex align-center justify-between">
                <div class="flex align-center ">
                    <el-input v-model="searchName" placeholder="请输入关键字"/>
                    <el-button
                        class="btn mid margin-left-xs"
                        type="primary"
                        @click="search"><i class="el-icon-search"></i>搜索
                    </el-button>
                </div>
                <div class="flex align-center">
                    <el-button
                        class="margin-left btn mid"
                        type="primary"
                        @click="addItem(false)" v-permission="'meeting'">新增
                    </el-button>
                    <el-button
                        class="margin-left btn mid"
                        type="primary"
                        @click="exportData()">导出
                    </el-button>
                    <el-button
                        class="margin-left btn mid"
                        type="primary"
                        @click="toPage(`/digitize`)">预览
                    </el-button>
                </div>
            </div>
            <div class="page-list flex flex-direction margin-top-sm">
                <el-table
                    v-loading="loading"
                    :data="lists"
                    border
                    header-row-class-name="table-header"
                    style="width: 100%">
                    <el-table-column label="序号" prop="index" width="80">
                        <template slot-scope="scope">
                            <div class="table-item">
                                {{ (scope.$index + 1) + (page - 1) * limit }}
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column label="议题" prop="title">
                        <template slot-scope="scope">
                            <div class="table-item">
                                {{ scope.row.title }}
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column label="时间" prop="meeting_time" width="150">
                        <template slot-scope="scope">
                            <div class="table-item">
                                {{ scope.row.meeting_time }}
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column label="地点" prop="address">
                        <template slot-scope="scope">
                            <div class="table-item">
                                {{ scope.row.address }}
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column label="状态" prop="status_name" width="150">
                        <template slot-scope="scope">
                            <div class="table-item">
                                {{ scope.row.status_name }}
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column fixed="right" label="操作" prop="end_time" width="220">
                        <template slot-scope="scope">
                            <div class="table-item text-sm">
                                <el-button type="text" @click="showItem(scope.row.id)">查看</el-button>
                                <el-button type="text" @click="addItem(scope.row)" v-permission="'meeting'">
                                    编辑
                                </el-button>
                                <el-button type="text" @click="delItem(scope.row)" v-permission="'meeting'">删除</el-button>
                                <el-button type="text" @click="exportData(scope.row.id)">导出</el-button>
                            </div>
                        </template>
                    </el-table-column>
                </el-table>
                <el-pagination
                    :current-page.sync="page"
                    :page-size="limit"
                    :total="total"
                    background
                    class="page-all margin-top self-end"
                    layout="prev, pager, next,total"
                    @current-change="getList">
                </el-pagination>
            </div>
        </div>
        <add-member-meeting-dialog :aid="cur_aid" :index="cur_index" :type="type" :dialog-visible="addMemberMeetingDialog"  @watchState="watchState"></add-member-meeting-dialog>
        <member-meeting-detail-dialog :aid="cur_aid" :type="type" :dialog-visible="memberMeetingDetailDialog"  @watchState="watchState"></member-meeting-detail-dialog>
    </div>
</template>

<script>
import {confirm, downloadFile, TOAST, toast, zhDate} from "@/utils/utils";
import {delMeeting, exportMeeting, getMeetingList} from "@/api";
import AddMemberMeetingDialog from "@/views/web/manager/page/meeting/components/AddMemberMeetingDialog";
import MemberMeetingDetailDialog from "@/views/web/manager/page/meeting/components/MemberMeetingDetailDialog";

export default {
    name: "meeting_council-list",
    components: {MemberMeetingDetailDialog, AddMemberMeetingDialog},
    data() {
        return {
            type:2,
            searchName: '',
            lists: [],
            page: 1,
            limit: 10,
            total: 0,
            loading: false,
            cur_aid: 0,
            cur_index: 0,
            addMemberMeetingDialog: false,
            memberMeetingDetailDialog: false,
        };
    },
    props: {},
    computed: {
        user() {
            return this.$store.state.user
        },
    },
    created() {
        this.init()
    },
    activated() {
        this.init()
    },
    methods: {
        init() {
            this.$emit('setIndex', [1, 1])
            this.getList()
        },
        async getList() {
            this.loading = true
            let _data = await getMeetingList(this.type,this.searchName, this.page, this.limit)
            this.lists = _data.data.data
            this.total = _data.data.total
            this.loading = false
        },
        search() {
            this.page = 1
            this.getList()
        },
        addItem(data) {
            if (data) {
                this.cur_index = Math.min(data.status,2)
                this.cur_aid = data.id;
            } else {
                this.cur_index = 0
                this.cur_aid = 0
            }
            this.addMemberMeetingDialog = true;
        },
        async exportData(id = '') {
            let _data = await exportMeeting(this.type, id)
            if (_data.status === 200) {
                downloadFile(_data.data, `决策会议.${id ? 'docx' : 'zip'}`)
            } else {
                toast(_data.msg, TOAST.error)
            }
        },
        toPage(path) {
            this.$router.push(path)
        },
        delItem(item) {
            confirm(`删除`, `你确定删除<b>${item.title}</b>吗？`, () => {
                this.submitDel(item.id)
            }, '确认', true)
        },
        async submitDel(id) {
            let _data = await delMeeting(id)
            if (_data.status === 200) {
                toast('删除成功', TOAST.success)
                this.getList()
            } else {
                toast(_data.msg, TOAST.error)
            }
        },
        showItem(item) {
            this.cur_aid = item
            this.memberMeetingDetailDialog = true
        },
        watchState(data) {
            console.log(data)
            if (data) {
                this.cur_aid = Number(data);
                this.getList();
            } else {
                this.cur_index = -1;
                this.cur_aid = 0;
                this.addMemberMeetingDialog = false
                this.memberMeetingDetailDialog = false
            }
        }
    },
    filters: {
        zhDate(val) {
            return zhDate(val, 2)
        },
    },
}
</script>

<style lang="scss" scoped>
.content-wrapper {

    .search-item {
        margin-bottom: 20px;
    }

    .search-tip {
        width: 120px;
        text-align: right;
    }

}
</style>